/* eslint-disable camelcase */
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from "react"
import { observer } from "mobx-react-lite"
import {
  Appearance,
  ImageStyle,
  ViewStyle,
  NativeSyntheticEvent,
  NativeScrollEvent,
  ImageBackground,
  Alert,
  Platform,
  InteractionManager,
} from "react-native"
import { AutoImage, Button, FlatList, JalaIcon, ListRenderItem, ListRenderItemInfo, Screen, Text } from "../../../../components"
import { color } from "../../../../theme"
import { CompositeScreenProps, useIsFocused, useLinkTo, useNavigation } from "@react-navigation/native"
import { View } from "native-base"
import { useStores } from "../../../../models"
import { Slider } from "../../start/start-screen"
import { translate } from "../../../../i18n"
import { LinearGradient } from "expo-linear-gradient"
import config from "../../../../utils/config"
import moment from "moment"
import axios from "axios"
import useWindowDimensions from "../../../../utils/use-window-dimensions"
import JalaAnalytic from "../../../../utils/jala-analytic"
import { HeaderBackButtonProps } from "@react-navigation/elements"
import { delay } from "../../../../utils/delay"
import { LazyRender } from "../../../../components/lazy-render/lazy-render"

const pattern = require("./pattern2.png")

const ROOT: ViewStyle = {
  flexGrow: 1,
}

const BUTTON: ViewStyle = {
  flex: 1
}

const IMAGE: ImageStyle = {
  flex: 1,
  justifyContent: "center",
}

const CARD: ViewStyle = {
  backgroundColor: 'white',
  borderRadius: 16,
  alignItems: 'center',
  shadowColor: color.primary,
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowOpacity: 1,
  shadowRadius: 4,
  elevation: 5,
}

const BUTTON_ANSWER = (active):ViewStyle => ({
  width: '100%',
  marginVertical: 10,
  backgroundColor: active ? color.primary : color.palette.white,
  borderColor: active ? color.palette.white : undefined,
  borderWidth: active ? 1 : 0
})

const HELP_BUTTON: ImageStyle = {
  marginHorizontal: 20
}

const BACK_BUTTON: ViewStyle = {
  marginLeft: 20,
  marginRight: 16,
  alignItems: 'center',
}

const PREV_BUTTON: ViewStyle = {
  ...BUTTON,
  borderWidth: 0,
  backgroundColor: "transparent"
}

const LINEAR: ViewStyle = {
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,
}

const IMG_PROFILE: ImageStyle = {
  width: 34,
  height: 34,
  borderRadius: 34 / 2,
  backgroundColor: color.primaryDarker
}

const CONTENT_CONTAINER: ViewStyle = {
  alignItems: "flex-end"
}

export const questions = [
  {
    id: 1,
    question: "Apa yang terjadi saat malam bulan purnama?",
    key: 2,
    answers: [
      "Air laut pasang rendah",
      "Nafsu udang meningkat",
      "Udang moulting",
      "Air laut surut"
    ],
    note: "Setiap bulan purnama, udang akan moulting atau berganti kulit massal sehingga jumlah mineral di kolam perlu dicukupkan agar proses moulting berjalan lancar"
  },
  {
    id: 2,
    question: "Apa yang menjadi sumber oksigen di kolam saat malam hari?",
    key: 2,
    answers: [
      "Plankton",
      "Bakteri",
      "Kincir",
      "Zooplankton"
    ],
    note: "Dimalam hari oksigen akan sangat rendah karena udang, bakteri dan plankton menggunakan oksigen bersamaan. Kincir adalah salah satu solusi untuk mencukupi kebutuhan oksigen di kolam pada malam hari."
  },
  {
    id: 3,
    question: "Apa yang terjadi di kolam udang saat musim penghujan?",
    key: 1,
    answers: [
      "Jumlah bakteri vibrio menurun",
      "pH menurun",
      "Jumlah plankton naik",
      "pH naik"
    ],
    note: "Air hujan memiliki kadar pH yang rendah, sehingga apabila turun hujan bisa membuat pH air kolam turun.Solusi untuk menaikkan pH air kolam bisa dengan cara tebar kapur seperti dolomit atau kaptan ke kolam."
  },
  {
    id: 4,
    question: "Apa yang terjadi pada udang saat suhu di kolam rendah?",
    key: 0,
    answers: [
      "Penurunan nafsu makan udang",
      "Udang kedinginan",
      "Metabolisme udang tetap stabil",
      "Nafsu makan udang naik"
    ],
    note: "Suhu yang rendah akan menurunkan konsumsi pakan udang, yaitu sekitar 10% per derajat celcius penurunan suhu.Suhu yang disarankan untuk udang vannamei adalah 28-32°C."
  },
  {
    id: 5,
    question: "Apa fungsi penebaran kaporit pada kolam udang?",
    key: 0,
    answers: [
      "Menekan jumlah bakteri dan virus",
      "Menaikkan pH",
      "Menurunkan pH",
      "Mempercepat proses moulting"
    ],
    note: "Penebaran kaporit pada kolam udang dapat menekan jumlah bakteri dan virus yang dapat menyebabkan penyakit pada udang, selain itu juga membantu agar udang tidak mudah stress. Dosis kaporit yang disarankan adalah sekitar 20-60 ppm."
  },
  {
    id: 6,
    question: "Apakah warna Hepatopankreas disaat udang sehat?",
    key: 1,
    answers: [
      "Berwarna hitam",
      "Berwarna coklat",
      "Berwarna hijau",
      "Berwarna merah"
    ],
    note: "Di saat udang sehat, hepatopankreas berwarna coklat sehingga apabila hepatopankreas tidak berwarna coklat udang sedang dalam kondisi tidak sehat."
  },
  {
    id: 7,
    question: "Apa penyebab penurunan nafsu makan udang?",
    key: 3,
    answers: [
      "Pergantian air",
      "Pakan baru",
      "Suhu stabil",
      "Udang moulting"
    ],
    note: "Molting adalah proses pergantian kulit/cangkang udang. Ketika molting terjadi udang akan cenderung memuasakan diri dan menggunakan protein pada tubuh untuk pembentukan cangkang baru."
  },
  {
    id: 8,
    question: "Apa penyebab udang naik ke permukaan kolam?",
    key: 0,
    answers: [
      "Underfeeding",
      "Oksigen terlarut tinggi",
      "Overfeeding",
      "Berkurangnya padat tebar bibit udang"
    ],
    note: "Underfeeding adalah kondisi saat kebutuhan makanan pada udang tidak tercukupi. Ketika hal ini terjadi udang naik ke permukaan untuk mencari makanan"
  },
  {
    id: 9,
    question: "Apa nama alat yang dapat membantu produksi oksigen pada kolam udang?",
    key: 2,
    answers: [
      "JALA App",
      "JALA Web",
      "JALA Dojeto",
      "JALA Baruno"
    ],
    note: "Jala Dojeto adalah solusi dari Jala untuk membantu menghasilkan oksigen tambahan dan arus perputaran air di kolam udang."
  },
  {
    id: 10,
    question: "Bagaimana caranya mengetahui nafsu makan udang ?",
    key: 0,
    answers: [
      "Kontrol Anco",
      "Kontrol kualitas air",
      "Kontrol pH",
      "Kontrol pakan"
    ],
    note: "Salah satu fungsi ancho adalah untuk mengetahui nafsu makan udang. Sehingga ketika pakan udang di ancho masih ada sisa, pemberian pakan bisa dikurangi untuk mencegah overfeeding."
  },
]

export const HelpButton: FC = observer(function HelpButton(props) {
  const image = require("./help.png")

  return(<Slider>
    <AutoImage source={image} style={HELP_BUTTON} />
  </Slider>)
})

export const BackButton: FC<HeaderBackButtonProps> = observer(function HelpButton(props) {
  const navigation = useNavigation()
  const backIcon = Platform.OS === "ios" ? 'arrow_back_ios' : 'arrow_back';

  const onBack = useCallback(() => {
    navigation.goBack();
  }, [navigation])

  return (<Button preset="link" onPress={onBack} style={BACK_BUTTON}>
    <JalaIcon name={backIcon} size={24} color={color.palette.white} />
  </Button>)
})

const Timer: FC<{ colorScheme?: "light" | "dark", startTime?: number }> = function Timer(props) {
  const { colorScheme, startTime } = props
  const [ elapsedTime, setElapsedTime ] = useState<number>(0)
  const isFocused = useIsFocused()

  useEffect(() => {
    if (!isFocused) return undefined;
    let unmount = false;
    let timeoutId;
    function startTimeout() {
      timeoutId = setTimeout(() => {
        if (unmount) return;
        InteractionManager.runAfterInteractions(() => {
          if (!unmount) setElapsedTime(moment().valueOf() - startTime)
          startTimeout();
        })
      }, 50)
    }
    startTimeout();
    return () => {
      unmount = true;
      timeoutId && clearTimeout(timeoutId);
    }
  }, [isFocused, startTime])

  return <Text
    preset="display3"
    text={moment(elapsedTime).format('mm\'ss"SSS')}
    ml="7px"
    color={color.palette.white}
    colorScheme={colorScheme}
  />
}

const Item: FC<{ colorScheme?: "light" | "dark", info: ListRenderItemInfo<any>, data?: Array<any>, handleButton?: (item: any) => void, handleAnswer?: (item: any) => void, handleNavigate?: () => void }> = (props) => {
  const { colorScheme = "light" || Appearance.getColorScheme(), info, data = [], handleButton, handleAnswer, handleNavigate } = props;
  const { item: { fields: { question, answers, id } }, index } = info;

  const nextDisabled = !data[index]
  const last = index === 9;

  const [ active, setActive ] = useState<number>(null);
  const [ act, setAct ] = useState<boolean>(false)

  const dimension = useWindowDimensions()

  const onClick = useCallback((value) => {
    handleButton(value)
  },[handleButton])

  const onPress = useCallback((value) => {
    setActive(value.answerKey);
    setAct(true);
    handleAnswer({ id, ...value })
    if (!last) onClick(true)
    setTimeout(() => {
      setAct(false);
    }, 2000)

  }, [handleAnswer, id, last, onClick])


  return (
    <View minHeight={dimension.height - 134} width={dimension.width} justifyContent="space-between" backgroundColor="transparent">
      <View flex={1} justifyContent="center" px="20px" mb="20px">
        <View mb="32px">
          <Text preset="title3" alignSelf="center" tx="startQuizScreen.questionTitle" colorScheme={colorScheme} />
        </View>
        <View
          alignItems="center"
          backgroundColor={color.palette.white}
          style={CARD}
          borderWidth="1px"
          borderColor={color.palette.white}
          mx="16px"
          px="12px"
          py="30px"
          borderRadius="6px"
          position="relative"
        >
          <View position="absolute" flexDirection="row" alignItems="center" py="8px" px="19px" top="-20px" backgroundColor={color.primary} borderRadius="4px">
            <View width="8px" height="8px" mr="7px" borderRadius="4px" backgroundColor={color.palette.white} />
            {/* <Text preset="title3" text={`${info.index + 1} dari ${questions.length} pertanyaan`} color={color.palette.white} colorScheme={colorScheme} /> */}
            <Text preset="title3" text={translate("startQuizScreen.questionLength", { index: `${info.index + 1}`})} color={color.palette.white} colorScheme={colorScheme} />
            <View width="8px" height="8px" ml="7px" borderRadius="4px" backgroundColor={color.palette.white} />
          </View>
          <Text preset="title2" textAlign="center" px="16px" text={question} color={color.primary} colorScheme={colorScheme} />
        </View>
      </View>
      <LinearGradient
        colors={['#0082F3', '#45AAE3']}
        style={LINEAR}
        start={{ x: 0.0, y: 0.0 }}
        end={{ x: 1, y: 1}}
      >
      <View width={dimension.width} pt="20px" px="32px" borderTopRadius="16px">
        {answers.map((answer, index) => <Button
          key={index}
          text={answer}
          style={BUTTON_ANSWER(active === index)}
          colorScheme={colorScheme}
          textColor={active !== index ? color.primary : color.palette.white}
          onPress={() => {
            // if (active) return;
            if (act) return;
            onPress({ answerKey: index, answer })
            // if (!last) onClick(true)
          }}
        />)}
        <View py="16px" flexDirection="row">
          <Button
            testID="jala:id/quiz-previous-button"
            tx="homeScreen.tooltipPrevious"
            style={PREV_BUTTON}
            preset="outline"
            textColor={index === 0 ? color.palette.gray400 : color.palette.white}
            disabled={index === 0}
            colorScheme={colorScheme}
            onPress={() => onClick(false)}
          />
          <View width="16px" />
          <Button
            testID="jala:id/quiz-next-button"
            tx={!last ? `common.next`: `common.done`}
            style={[BUTTON, { backgroundColor: nextDisabled ? color.palette.gray500 : color.palette.orange500}]}
            disabled={nextDisabled}
            colorScheme={colorScheme}
            onPress={last ? handleNavigate : () => onClick(true)}
          />
        </View>
      </View>
      </LinearGradient>
    </View>
  )
}

export const QuestionDetailScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function QuestionDetailScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), navigation } = props
  const linkTo = useLinkTo()

  const [ index, setIndex ] = useState<number>(0);
  const [ answers, setAnswers ] = useState<Array<any>>([]);
  const [ uniqId, setUniqId ] = useState<string>(null);
  const [ lastRecord, setLastRecord ] = useState<any>(null);

  const FlatListRef = useRef<FlatList<any>>()

  const dimension = useWindowDimensions()

  // Pull in one of our MST stores
  const { quizStore, quizStore: { questions: quest, times }, userStore: { user } } = useStores()

  const { BASE_URL, AIRTABLE_BASE_ID, AIRTABLE_API_KEY, AIRTABLE_LEADERBOARD } = config();

  const imageTimer = require("./timer.png");

  const avatar = useMemo(() => {
    return { uri: `${BASE_URL}/img/cache/medium/${user.avatar}`}
  },[BASE_URL, user.avatar])

  const result = useMemo(() => {
    return quest.filter(question => answers.some(answer => answer.id === question.fields.id && answer.answerKey === question.fields.key))
  },[answers, quest])

  useEffect(() => {
    fetchData()
  },[])

  useEffect(() => {
    const callback = async (e) => {
      if (!navigation.isFocused()) return;
      e.preventDefault();
      await delay(10);
      Alert.alert(
        translate("startQuizScreen.warningTitle"),
        translate("startQuizScreen.warningSubtitle"),
        [
          { text: translate("startQuizScreen.continue"), style: 'cancel', onPress: () => undefined },
          {
            text: translate("common.back"),
            style: 'destructive',
            onPress: () => {
              navigation.dispatch(e.data.action);
            },
          },
        ]
      );
    }
    navigation.addListener('beforeRemove', callback)
    return () => navigation.removeListener('beforeRemove', callback)
  }, [navigation]);

  const fetchData = () => {
    axios.get(`https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_LEADERBOARD}`, {
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${AIRTABLE_API_KEY}`,
      },
      params: {
        filterByFormula: `(user_id=${user.id})`
      }
    })
    .then(response =>  {
      if (response.status === 200) {
        const { data } = (response || {})
        if (data.records.length){
          setUniqId(data.records[0].id)
          setLastRecord(data.records[0])
        }
      }
      else fetchData()
    })
    .catch(err => console.warn(err))
  }

  const create = useCallback((data) => {
    return axios.post(`https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_LEADERBOARD}`, data, {
      headers: {
        'Authorization': `Bearer ${AIRTABLE_API_KEY}`,
        'Content-Type': 'application/json',
      },
    }).catch(err => console.warn(err))
  },[AIRTABLE_API_KEY, AIRTABLE_BASE_ID, AIRTABLE_LEADERBOARD])

  const update = useCallback((data) => {
    return axios.patch(`https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_LEADERBOARD}/${uniqId}`, data, {
      headers: {
        'Authorization': `Bearer ${AIRTABLE_API_KEY}`,
        'Content-Type': 'application/json',
      },
    })
      .catch(err => console.warn(err))
  },[AIRTABLE_API_KEY, AIRTABLE_BASE_ID, AIRTABLE_LEADERBOARD, uniqId])

  const handleButton = useCallback((next: boolean) => {
    if (next) {
      if (questions.length > index) setIndex(index + 1);
      FlatListRef.current.scrollToOffset({ offset: dimension.width * (questions.length > index ? index + 1 : index) })
    }
    else {
      if (questions.length > 1) setIndex(index - 1);
      FlatListRef.current.scrollToOffset({ offset: dimension.width * (questions.length > index ? index - 1 : index) })
    }
  }, [dimension.width, index])

  const handleAnswer = useCallback((data) => {
    const result = answers.map(item => item.id === data.id ? data : item)
    const array = [...result, data];
    const uniq = [...new Set(array)]
    setAnswers(uniq)
  }, [answers])

  const handleNavigate = useCallback(() => {
    const time = moment().valueOf()
    const obj = {
      fields: {
        user_id: user.id,
        user_name: user.name,
        elapsed_time: (time - times[0]) / 1000,
        score: result.length,
        best_score: lastRecord?.fields?.best_score || 0,
        best_elapsed_time: lastRecord?.fields?.best_elapsed_time || 0
      }
    }

    if (result.length > (lastRecord?.fields?.best_score || 0)) {
        obj.fields.best_score = result.length;
        obj.fields.best_elapsed_time = (time - times[0]) / 1000;
    } else if (result.length === (lastRecord?.fields?.best_score || 0) && ((time - times[0]) / 1000) > (lastRecord?.fields?.best_elapsed_time || 0)) {
        obj.fields.best_elapsed_time = (time - times[0]) / 1000;
    }

    const { elapsed_time, score } = obj.fields
    JalaAnalytic.log('Mobile app: Quiz Submit', { elapsed_time, score })

    if (uniqId) update(obj).catch()
    else create(obj).catch()

    quizStore.set('answers', answers)
    quizStore.set("times", [...quizStore.times, time])
    linkTo('/Quiz.Result')
  },[user, times, result.length, lastRecord, uniqId, update, create, quizStore, answers, linkTo])

  const onScroll = useCallback((event: NativeSyntheticEvent<NativeScrollEvent>) => {
    FlatListRef.current.scrollToOffset({ offset: index * (dimension.width) });
  }, [dimension.width, index])

  const renderItem: ListRenderItem<any> = useCallback((info) => {
    return <Item info={info} data={answers} handleButton={handleButton} handleAnswer={handleAnswer} handleNavigate={handleNavigate} colorScheme={colorScheme} />
  }, [answers, colorScheme, handleAnswer, handleButton, handleNavigate])

  const keyExtractor = useCallback((item, index) => `${item.id || index}`, [])

  return (<ImageBackground source={pattern} style={IMAGE} resizeMode="repeat">
    <View py="12px" position="absolute" justifyContent="center" top="0" left="0" right="0">
      <View
        backgroundColor={color.primary}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        mx="16px"
        px="16px"
        py="6px"
        borderRadius="5px"
      >
        <View flex={1} flexDirection="row" alignItems="center">
          <AutoImage source={avatar} style={IMG_PROFILE} />
          <Text preset="title4" text={user.name} mx="8px" numberOfLines={1} ellipsizeMode="tail" color={color.palette.white} colorScheme={colorScheme} />
        </View>
        <View flexDirection="row" alignItems="center">
          <AutoImage source={imageTimer} />
          <LazyRender>
            <Timer colorScheme={colorScheme} startTime={quizStore.times[0]} />
          </LazyRender>
        </View>
      </View>
    </View>
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      backgroundColor="transparent"
      statusBar={colorScheme === 'light' ? 'light-content' : 'dark-content'}
    >
      <FlatList
        ref={FlatListRef}
        keyExtractor={keyExtractor}
        data={quest}
        renderItem={renderItem}
        horizontal
        pagingEnabled
        showsHorizontalScrollIndicator={false}
        nestedScrollEnabled
        estimatedItemSize={dimension.width}
        scrollEventThrottle={1000}
        onScroll={onScroll}
        contentContainerStyle={CONTENT_CONTAINER}
      />
      {/* <View width={dimension.width} backgroundColor={color.primary} p="16px" position="absolute" bottom="0" flexDirection="row">
        <Button
          testID="jala:id/quiz-previous-button"
          tx="common.back"
          style={[BUTTON, { backgroundColor: index === 0 ? color.primary : undefined }]}
          preset="outline"
          textColor={index === 0 ? color.palette.gray400 : color.palette.white}
          disabled={index === 0}
          colorScheme={colorScheme}
          onPress={() => handleButton(false)}
        />
        <View width="16px" />
        <Button
          testID="jala:id/quiz-next-button"
          tx="common.next"
          style={[BUTTON, { backgroundColor: answers.length === index && index !== (answers.length - 1) ? color.palette.gray500 : color.palette.orange500}]}
          // disabled={(!finish && (data.length - 1) === index)}
          disabled={answers.length === index && index !== (answers.length - 1)}
          colorScheme={colorScheme}
          onPress={finish ? handleNavigate : () => handleButton(true)}
        />
      </View> */}
    </Screen>
  </ImageBackground>)
})
